import React, { useCallback, useRef, useState } from 'react';
import { TabHeader } from 'src/components/atoms';
import {
  TabPanel,
  TabsHeaderContainer,
  TabsPanelsContainer,
} from './Tabs.styles';

interface TabsProps {
  headers: Array<string>;
  panels: React.ReactNode[];
  handleTracking?: (index: number) => void;
  onClick: (index: number) => void;
  activeTab: number;
  className?: string;
}

export const Tabs = ({
  headers,
  panels,
  handleTracking,
  onClick,
  activeTab,
  className,
}: TabsProps) => {
  const handleClick = (index: number) => {
    handleTracking?.(index);
    onClick(index);
  };

  const tabWidthRef = useRef<Record<number, number>>({});
  const [longestWidth, setLongestWidth] = useState<number | undefined>();

  const onTabWidthChanged = useCallback(
    (index: number, width: number | undefined) => {
      if (!width) {
        delete tabWidthRef.current[index];
      } else {
        tabWidthRef.current[index] = width;
      }

      const maxWidth = Math.max(...Object.values(tabWidthRef.current));

      if (maxWidth === -Infinity) {
        setLongestWidth(undefined);
      } else {
        setLongestWidth(maxWidth);
      }
    },
    [],
  );

  return (
    <>
      <TabsHeaderContainer>
        {headers.length > 0 &&
          headers.map((header, index) => (
            <TabHeader
              key={index}
              index={index}
              active={index === activeTab}
              forceWidth={longestWidth}
              onClick={() => handleClick(index)}
              onWidthChange={onTabWidthChanged}
              label={header}
            />
          ))}
      </TabsHeaderContainer>
      <TabsPanelsContainer className={className}>
        {panels.map((panel, index) => (
          <TabPanel key={index} active={index === activeTab}>
            {panel}
          </TabPanel>
        ))}
      </TabsPanelsContainer>
    </>
  );
};
